import { definePreset, palette } from '@primeuix/themes'
import Nora from '@primeuix/themes/nora'

export const spdPreset = definePreset(Nora, {
  semantic: {
    primary: palette('#E8751A'),
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8f8f9',
          100: '#f0f0f2',
          200: '#e4e4e8',
          300: '#c8c8d0',
          400: '#9898a8',
          500: '#686878',
          600: '#484858',
          700: '#323248',
          800: '#252538',
          900: '#1A1A2E',
          950: '#12121f',
        },
      },
    },
  },
  components: {
    accordion: {
      panel: {
        borderWidth: '0',
      },
      header: {
        borderRadius: '0',
        borderWidth: '0 0 1px 0',
        borderColor: '{surface.200}',
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.0}',
        activeColor: '{surface.800}',
        padding: '0.75rem 1rem',
        fontWeight: '600',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
        first: {
          topBorderRadius: '0',
          borderWidth: '0 0 1px 0',
        },
        last: {
          bottomBorderRadius: '0',
          activeBottomBorderRadius: '0',
        },
        toggleIcon: {
          color: '{surface.500}',
          activeColor: '{surface.500}',
        },
      },
      content: {
        borderWidth: '0',
        padding: '1rem',
        background: '{surface.0}',
      },
    },
    datepicker: {
      dropdown: {
        background: '{surface.0}',
        borderColor: '{surface.200}',
        color: '{surface.500}',
        hoverBackground: '{surface.50}',
        hoverBorderColor: '{surface.200}',
        activeBackground: '{surface.100}',
        activeBorderColor: '{surface.200}',
        borderRadius: '4px',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
      },
    },
  },
})
